import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import "./HomeSections.css";

// Boot verisinden türetilen güven şeridi: ilan/kategori sayıları + sabit vaatler.
function formatCount(n) {
  if (!n) return "0";
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function StatsBand() {
  const { categories } = useSelector(
    (state) => ({ categories: state.category.categories }),
    shallowEqual
  );

  const totalAdverts = (categories || []).reduce(
    (sum, c) => sum + (Number(c.rate) || 0),
    0
  );

  const stats = [
    { num: totalAdverts ? `${formatCount(totalAdverts)}+` : "—", label: "Aktif İlan" },
    { num: formatCount((categories || []).length), label: "Kategori" },
    { num: "81", label: "İl" },
    { num: "Ücretsiz", label: "İlan Ver" },
  ];

  return (
    <div className="hs-section container">
      <div className="hs-stats">
        {stats.map((s) => (
          <div className="hs-stat" key={s.label}>
            <div className="hs-stat__num">{s.num}</div>
            <div className="hs-stat__label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StatsBand;
